import React from "react";
import { Checkbox, FormControlLabel, MenuItem, TextField } from "@mui/material";
import { DropDownComboOption } from "./GenericFilter";
import { propsToClassKey } from "@mui/styles";
import { Padding } from "@mui/icons-material";

export type DropDownTextBoxProps = {
    dropDownBoxId?: string;
    dropDownBoxLabel?: string;
    dropDownBoxDisabled: boolean;
    className: string;
    dropDownBoxWidth: string;
    dropDownBoxOptions: DropDownComboOption[];
    dropDownBoxValue: string;
    firstTextBoxLabel?: string;
    firstTextBoxName?: string;
    firstTextBoxValue?: string;
    firstTextBoxWidth?: string
    firstTextBoxMinWidth?: string;
    firstTextBoxReadOnly?: boolean;
    firstTextBoxTextLength?: number;
    onSelectionChanged: Function;
    onTextBoxValueChanged: Function;
    onCheckBoxValueChanged: Function;
    checked: boolean;
    checkBoxDisabled: boolean;
}

export function CustomDropDown3(props: DropDownTextBoxProps ) {
    const componentStyle = {
        display: 'flex'
    };

    const checkboxLabelStyle = {
        border: "none",
        minWidth: '88px',
        height: '24px',
        paddingTop: 8,
        paddingLeft: 0,
        paddingRight: 0,
        marginLeft: 0,
        marginRight: 0
    };
      
    const [selectedValue, setSelectedValue] = React.useState<string | null>(props.dropDownBoxValue);

    const selectedValueChanged = (newValue: string | null) => {
        setSelectedValue(newValue);
        props.onSelectionChanged(newValue);
    };
 
    const firstTextBoxValueChanged = (newValue: string | null) => {
        props.onTextBoxValueChanged(newValue);
    };

    const checkboxValueChanged = (newValue: boolean) => {
         props.onCheckBoxValueChanged(newValue);
    };

    return (
        <div className={props.className} style={componentStyle}>
            <TextField
                id={props.dropDownBoxId}
                style={{width: props.dropDownBoxWidth}}
                value={selectedValue}
                onChange={(e) => selectedValueChanged(e.target.value)}
                select
                label={props.dropDownBoxLabel}
                disabled={props.dropDownBoxDisabled}
                size="small"
                fullWidth
            >
                {props.dropDownBoxOptions.map((item)=> (
                    <MenuItem key={item.value} value={item.value}>
                        {item.name}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                label={props.firstTextBoxLabel}
                InputLabelProps={{ shrink: true }}
                name={props.firstTextBoxName}
                value={props.firstTextBoxValue}
                variant="outlined"
                inputProps={
                    { readOnly: props.firstTextBoxReadOnly, maxLength: props.firstTextBoxTextLength }
                }
                onChange={(e) => firstTextBoxValueChanged(e.target.value)}
                style={{width: props.firstTextBoxWidth, minWidth: props.firstTextBoxMinWidth}}
                size="small"
                fullWidth
            />
            <FormControlLabel
                style={checkboxLabelStyle}
                control={
                <Checkbox checked={props.checked} 
                    onChange={(e) => checkboxValueChanged(e.target.checked)} 
                    disabled={props.checkBoxDisabled} 
                />
                }
                label="Next Month"
            />
        </div>
    );
}

